import { Timestamp } from 'firebase/firestore';

import { Atm, AtmOperationType, AtmTheme } from '../types/atm';

/**
 * Sample ATM data for development and testing
 */
export const mockAtms: Atm[] = [
  {
    id: 'atm1',
    name: 'Basic Withdrawal ATM',
    description: 'A simple ATM with withdrawal options',
    createdBy: 'user1',
    createdByName: 'Anonymous User',
    createdAt: Timestamp.fromDate(new Date('2023-06-15')),
    updatedAt: Timestamp.fromDate(new Date('2023-06-15')),
    theme: AtmTheme.DEFAULT,
    isPublic: true,
    transactionCount: 42,
    atmSettings: {
      requirePin: true,
      defaultPin: '1234',
      animationSpeed: 1,
      showInExplore: true,
      sounds: {
        enabled: true,
      },
    },
    options: [
      {
        id: 'option1',
        text: 'Withdraw $20',
        type: AtmOperationType.WITHDRAWAL,
        amount: 20,
        enabled: true,
        position: 0,
      },
      {
        id: 'option2',
        text: 'Withdraw $50',
        type: AtmOperationType.WITHDRAWAL,
        amount: 50,
        enabled: true,
        position: 1,
      },
      {
        id: 'option3',
        text: 'Withdraw $100',
        type: AtmOperationType.WITHDRAWAL,
        amount: 100,
        enabled: true,
        position: 2,
      },
      {
        id: 'option4',
        text: 'Check Balance',
        type: AtmOperationType.BALANCE,
        enabled: true,
        position: 3,
      },
      {
        id: 'option5',
        text: 'Cancel',
        type: AtmOperationType.CANCEL,
        enabled: true,
        position: 4,
      },
    ],
  },
  {
    id: 'atm2',
    name: 'Full-Service ATM',
    description: 'An ATM with withdrawal, deposit and balance options',
    createdBy: 'user1',
    createdByName: 'Power User',
    createdAt: Timestamp.fromDate(new Date('2023-07-22')),
    updatedAt: Timestamp.fromDate(new Date('2023-07-28')),
    theme: AtmTheme.MODERN,
    isPublic: true,
    transactionCount: 123,
    atmSettings: {
      requirePin: true,
      defaultPin: '5678',
      animationSpeed: 1.2,
      showInExplore: true,
      sounds: {
        enabled: true,
      },
      messages: {
        welcome: 'Welcome to the Full-Service ATM',
      },
    },
    options: [
      {
        id: 'option1',
        text: 'Withdraw $20',
        type: AtmOperationType.WITHDRAWAL,
        amount: 20,
        enabled: true,
        position: 0,
      },
      {
        id: 'option2',
        text: 'Withdraw $50',
        type: AtmOperationType.WITHDRAWAL,
        amount: 50,
        enabled: true,
        position: 1,
      },
      {
        id: 'option3',
        text: 'Withdraw $100',
        type: AtmOperationType.WITHDRAWAL,
        amount: 100,
        enabled: true,
        position: 2,
      },
      {
        id: 'option4',
        text: 'Deposit $50',
        type: AtmOperationType.DEPOSIT,
        amount: 50,
        enabled: true,
        position: 3,
      },
      {
        id: 'option5',
        text: 'Deposit $100',
        type: AtmOperationType.DEPOSIT,
        amount: 100,
        enabled: true,
        position: 4,
      },
      {
        id: 'option6',
        text: 'Custom Amount',
        type: AtmOperationType.CUSTOM,
        customData: {
          operationType: AtmOperationType.WITHDRAWAL,
          promptMessage: 'Enter withdrawal amount:',
        },
        enabled: true,
        position: 5,
      },
      {
        id: 'option7',
        text: 'Check Balance',
        type: AtmOperationType.BALANCE,
        enabled: true,
        position: 6,
      },
      {
        id: 'option8',
        text: 'Cancel',
        type: AtmOperationType.CANCEL,
        enabled: true,
        position: 7,
      },
    ],
  },
  {
    id: 'atm3',
    name: 'Retro Bank',
    description: 'A nostalgic ATM with a retro theme',
    createdBy: 'user2',
    createdByName: 'Retro Lover',
    createdAt: Timestamp.fromDate(new Date('2023-08-05')),
    updatedAt: Timestamp.fromDate(new Date('2023-08-05')),
    theme: AtmTheme.RETRO,
    isPublic: true,
    transactionCount: 67,
    atmSettings: {
      requirePin: false,
      animationSpeed: 0.8,
      showInExplore: true,
      sounds: {
        enabled: true,
      },
    },
    options: [
      {
        id: 'option1',
        text: 'Fast Cash $20',
        type: AtmOperationType.WITHDRAWAL,
        amount: 20,
        enabled: true,
        position: 0,
      },
      {
        id: 'option2',
        text: 'Fast Cash $40',
        type: AtmOperationType.WITHDRAWAL,
        amount: 40,
        enabled: true,
        position: 1,
      },
      {
        id: 'option3',
        text: 'Fast Cash $60',
        type: AtmOperationType.WITHDRAWAL,
        amount: 60,
        enabled: true,
        position: 2,
      },
      {
        id: 'option4',
        text: 'Account Balance',
        type: AtmOperationType.BALANCE,
        enabled: true,
        position: 3,
      },
      {
        id: 'option5',
        text: 'Exit',
        type: AtmOperationType.CANCEL,
        enabled: true,
        position: 4,
      },
    ],
  },
];
